export const extractFileNameFromUrl = (resourceUrl: string): string => {
    const splitUrl = decodeURIComponent(resourceUrl.split('?sv=')[0]).split('/');
    const fileEncoded = splitUrl[splitUrl.length - 1];
    return decodeURI(fileEncoded);
};
